import { getIventisEnvironmentData, permissionsApi } from "@iventis/api/src/api";
import { PublicProject } from "@iventis/domain-model/model/publicProject";

/**
 * Get the public project information from the API. This can be accessed without being logged in.
 * @param {string} shortName - The short name of the project.
 */
export const getPublicProject = async (shortName: string): Promise<PublicProject> => {
    try {
        const res = await permissionsApi.get<PublicProject>(`projects/${shortName}/public`);
        return res.data;
    } catch (e) {
        // This means the public project does not exist. In this case we should re-direct back to the projectless login page of environment.
        const { appUrl, appProtocol } = getIventisEnvironmentData();
        if (e.response?.status === 404) {
            window.location.replace(`${appProtocol}${appUrl}`);
        }
        throw e;
    }
};
